import React, { lazy } from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
export function Hero() {
  return <section className="bg-brand-dark text-brand-text pt-8 pb-8 px-4 relative" data-id="element-107">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-108">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-6 leading-tight text-brand-text" data-id="element-109">
          Transformá tus clases de Filosofía con material profesional, editable
          y construido para el aula real de hoy.
        </h1>

        <div className="w-full max-w-[320px] md:max-w-md mx-auto mb-6 cursor-pointer" onClick={scrollToCompra} data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/ooMHHi4R8CpNMKMkKvZDQo/mockups-filosofia-2026.webp" alt="Kit Completo Filosofía Lista" className="w-full h-auto" loading="lazy" data-id="element-111" />
        </div>

        <p className="text-base md:text-lg mb-8 font-normal text-brand-text max-w-2xl mx-auto leading-relaxed" data-id="element-112">
          Planificá todo tu año de clases de Filosofía, Ética y Ciudadanía en
          una tarde — con teoría sólida, actividades que generan participación
          genuina y evaluaciones listas para usar.
        </p>

        <div className="w-full max-w-md mx-auto mb-6" data-id="element-113">
          <Button className="py-4 text-base md:text-lg" data-id="element-114">
            📜 → QUIERO MI KIT DE FILOSOFÍA AHORA
          </Button>
        </div>

        <div className="text-sm font-semibold text-brand-text/80" data-id="element-115">
          ✅ Garantía 7 días sin preguntas · 🔒 Pago 100% seguro · 💳 Pagás en
          tu moneda
        </div>
      </div>
    </section>;
}